import config from '@/config.js'

export default {
  user: null,
  token: null,
  refreshToken: null,
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  },
  message: null,
  settingParams: config.defaultSettingParams,
  logoutPage: null,
  showStartGuide: true,
  locale: 'en',
  serviceList: {  // main.jsで格納
    longNames: [],
    shortNames: [],
    codes: []
  },
  waterSystemDisplayMode: 'customer' // Home画面のクイックリンク用
}



// WEBPACK FOOTER //
// ./src/store/state.js